import { z } from 'zod';
import {
  createWidgetBaseConfigSchema,
  FieldConfigSchema,
  StringOrContextFunctionSchema,
} from './widget';
import { createThemeConfigSchema } from './theme';
import { ContextEngineSchemas } from '../context';

export const ConfigSchemas = {
  Field: FieldConfigSchema,
  Theme: createThemeConfigSchema({
    optional: false,
  }),
  WidgetBase: createWidgetBaseConfigSchema({
    optional: false,
  }),
  Widget: createWidgetBaseConfigSchema({
    optional: false,
  }).extend({
    apiUrl: z.string().optional(),
  }),
  UserWidget: createWidgetBaseConfigSchema({
    optional: true,
  }).extend({
    apiUrl: z.string().optional(),
  }),
  Context: ContextEngineSchemas.Config.optional(),
};

export namespace Config {
  export type Field = z.infer<typeof ConfigSchemas.Field>;

  /**
   * Internal field type with runtime metadata properties
   * Used during config processing and validation
   */
  export type FieldWithMetadata = Field & {
    _defaultValueIsFunction?: boolean;
  };

  export type Theme = z.infer<typeof ConfigSchemas.Theme>;
  export type Widget = z.infer<typeof ConfigSchemas.Widget>;
  export type WidgetBase = z.infer<typeof ConfigSchemas.WidgetBase>;
  export type UserWidget = z.infer<typeof ConfigSchemas.UserWidget>;
  export type Context = z.infer<typeof ConfigSchemas.Context>;
  // UI configuration type
  export type UI = z.infer<typeof ConfigSchemas.WidgetBase>['ui'];
  // Custom components
  export type CustomComponents = z.infer<
    typeof ConfigSchemas.WidgetBase
  >['customComponents'];
  export type CustomComponentNames = keyof CustomComponents;
  export type CustomComponent<K extends Config.CustomComponentNames> =
    NonNullable<Config.CustomComponents[K]>;

  export namespace ValueTypes {
    export type StringOrContextResultFunction = z.infer<
      typeof StringOrContextFunctionSchema
    >;
  }
}
